import { render, staticRenderFns } from "./SplashPortrait.vue?vue&type=template&id=a5d72cf2&"
import script from "./SplashPortrait.vue?vue&type=script&lang=js&"
export * from "./SplashPortrait.vue?vue&type=script&lang=js&"
import style0 from "./SplashPortrait.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports